import { API_VERSION, HOME_SERVICE, X_API_VERSION } from "../../../constants";
import { apiOptions, apiRequest } from "../../../utils";

const API_REQUIREMENTS = `${HOME_SERVICE}/requirements`;

export const requirements = {
  getAll: async ({ filters, sort, params, signal, top, skip } = {}) => {
    const options = await apiOptions({
      url: API_REQUIREMENTS,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
      signal,
      params,
      filters,
      sort,
      top,
      skip,
    });
    return apiRequest(options);
  },
  getById: async ({ id }) => {
    const options = await apiOptions({
      url: `${API_REQUIREMENTS}/${id}`,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
    });
    return apiRequest(options);
  },
  create: async ({ data, toastMessageConfig }) => {
    const options = await apiOptions({
      url: API_REQUIREMENTS,
      method: "post",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },
  update: async ({ id, data, toastMessageConfig }) => {
    const options = await apiOptions({
      url: `${API_REQUIREMENTS}/${id}`,
      method: "patch",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },
  delete: async ({ id, data, toastMessageConfig }) => {
    const options = await apiOptions({
      url: `${API_REQUIREMENTS}/${id}`,
      method: "delete",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },
};
